import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewEncapsulation,
    signal,
    ViewChild,
} from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25LoadingApi } from "../s25-loading/loading.api";
import { LangService } from "../../services/lang.service";
import { DataAccess } from "../../dataaccess/data.access";
import { EventService } from "../../services/event.service";
import { S25Util } from "../../util/s25-util";
import { S25Const } from "../../util/s25-const";
import { ContactService } from "../../services/contact.service";
import { UserprefService } from "../../services/userpref.service";
import { EventEmailService } from "../../services/event.email.service";
import { BpeService } from "../bpe/bpe.service";
import { FlsService } from "../../services/fls.service";
import { DocumentService } from "../../services/document.service";
import { PreferenceService } from "../../services/preference.service";
import { Report } from "../../pojo/Report";
import { TelemetryService } from "../../services/telemetry.service";
import { EmailService, EmailReport } from "../../services/email.service";
import { NotificationService } from "../../services/notification.service";
import { LoginService } from "../../services/login.service";
import {
    EventEmailDataI,
    apiBean,
    EmailRole,
    EmailReportSimpleObject,
    EmailReportObject,
    EmailField,
} from "../../pojo/EventEmailDataI";
import { S25File, FileList } from "../s25-file-upload/s25.file.upload.component";
import { AttachmentService } from "../../services/attachment.service";
import { S25ItemI } from "../../pojo/S25ItemI";
import { ObjectDetailsUtil } from "../../util/object.details.util";

@TypeManagerDecorator("s25-ng-email-event")
@Component({
    selector: "s25-ng-email-event",
    template: `
        <div class="moreActionsEmail">
            <div>
                <s25-loading-inline [model]="{}"></s25-loading-inline>
            </div>

            @if (init && data.init) {
                @if (data.templates.length > 0) {
                    <div class="c-margin-bottom--single">
                        @if (data.profiles.length > 1) {
                            <label>
                                Segment:
                                <select
                                    class="cn-form__control"
                                    [ngModel]="data.chosenProfile"
                                    (ngModelChange)="chooseProfile($event)"
                                >
                                    @for (item of data.profiles; track item.profile_id) {
                                        <option [ngValue]="item">{{ item.profile_name }}</option>
                                    }
                                </select>
                            </label>
                        }

                        <label>
                            <strong class="c-margin-right--quarter">Email Template</strong>
                            <select
                                class="cn-form__control"
                                [(ngModel)]="data.chosenTemplate"
                                (ngModelChange)="chooseTemplate($event)"
                            >
                                @for (item of data.templates; track "temp_" + item.itemId) {
                                    <option [ngValue]="item">{{ item.itemName }}</option>
                                }
                            </select>
                        </label>
                    </div>
                }

                <div class="email-details--wrapper">
                    <div>
                        @if (!hasGlobalFrom && data.canFrom && !data.fromEmail && !data.showFrom) {
                            <button
                                (click)="addFrom()"
                                class="aw-button aw-button--primary c-margin-bottom--single c-margin-top--half"
                            >
                                Add Custom From Address
                            </button>
                        }

                        @if (
                            (data.canFrom && data.fromEmail && data.showFrom) ||
                            (data.canFrom && !data.fromEmail && data.showFrom)
                        ) {
                            <label class="c-margin-bottom--single c-margin-top--half">
                                <strong>From Address:</strong>
                                <input
                                    aria-label="from address"
                                    type="text"
                                    name="from"
                                    [(ngModel)]="data.fromEmail"
                                    class="c-input"
                                />
                            </label>
                        } @else if (!data.canFrom && data.fromEmail) {
                            <label class="c-margin-bottom--single c-margin-top--half">
                                <strong>From Address:</strong>
                                <span class="c-padding-left--half">{{ data.fromEmail }}</span>
                            </label>
                        }

                        <p>
                            <strong>{{ data?.emailLang?.text?.related_recipients }}:</strong>
                        </p>
                        <table border="0" cellspacing="5" width="90%">
                            <thead>
                                <tr align="center">
                                    <th></th>
                                    <th width="34">{{ data?.emailLang?.text?.to }}</th>
                                    <th width="34">{{ data?.emailLang?.text?.cc }}</th>
                                    <th width="34">{{ data?.emailLang?.text?.bcc }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (role of data.roles; let i = $index; track "role_" + i) {
                                    <tr align="center">
                                        <th align="left" class="c-padding-bottom--half font--normal">
                                            @if (!role.text) {
                                                <ng-container>
                                                    <span>{{ role.roleName }}</span>
                                                    <p style="font-weight: normal">({{ role.contactName }})</p>
                                                    @if (!role.email) {
                                                        <div class="cn-alert cn-alert--danger">Invalid Email</div>
                                                    }
                                                </ng-container>
                                            }
                                            @if (role.text) {
                                                <ng-container>{{ role.text }}</ng-container>
                                            }
                                        </th>
                                        <td>
                                            <s25-ng-checkbox
                                                [(modelValue)]="role.isChosenTo"
                                                aria-label="role email"
                                                [disabled]="!role.email"
                                            >
                                            </s25-ng-checkbox>
                                        </td>
                                        <td>
                                            <s25-ng-checkbox
                                                [(modelValue)]="role.isChosenCC"
                                                aria-label="role email"
                                                [disabled]="!role.email"
                                            >
                                            </s25-ng-checkbox>
                                        </td>
                                        <td>
                                            <s25-ng-checkbox
                                                [(modelValue)]="role.isChosenBCC"
                                                aria-label="role email"
                                                [disabled]="!role.email"
                                            >
                                            </s25-ng-checkbox>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    <div class="email-details--recipients-reports">
                        <div class="email-details--additional-recipients c-margin-right--single">
                            <p>
                                <strong>{{ data?.emailLang?.text?.additional_recipients }}:</strong>
                            </p>
                            <!-- additional contacts -->

                            @for (field of emailFields; track field.id) {
                                <div class="c-margin-bottom--single c-margin-top--single">
                                    <s25-ng-multiselect-search-criteria
                                        [type]="'contacts'"
                                        [popoverOnBody]="true"
                                        [buttonText]="field.buttonText"
                                        [modelBean]="field.model"
                                        [useSecurity]="true"
                                        [popoverPlacement]="'bottom-left top-left top left'"
                                    ></s25-ng-multiselect-search-criteria>

                                    <input
                                        [attr.aria-label]="field.label + ' Emails'"
                                        [id]="field.id"
                                        type="text"
                                        [name]="field.id"
                                        [(ngModel)]="field.model.emailList"
                                        class="c-input input-spacer"
                                    />
                                </div>
                            }

                            <div class="ngFinePrint" style="width:260px">
                                {{ data?.emailLang?.text?.separate_with_commas }}
                            </div>
                        </div>

                        <div class="tblReports c-margin-left--half">
                            <p width="10%" align="left" valign="top" style="padding-top:5px">
                                <strong>{{ data?.emailLang?.text?.attach_file }}</strong>
                            </p>
                            <div style="padding-top:5px" class="email-details-attach-list">
                                <!-- actual reports -->
                                @for (report of data.reports; track report.rpt_name) {
                                    <div class="report">
                                        <s25-ng-checkbox [(modelValue)]="report.isChosen">
                                            {{ report.rpt_name }}
                                        </s25-ng-checkbox>

                                        @if (
                                            report.isChosen &&
                                            report.object_type === 13 &&
                                            data.organizations.length > 1
                                        ) {
                                            <label>
                                                Choose an Organization:
                                                <select
                                                    class="form-control"
                                                    [(ngModel)]="selectedOrgId"
                                                    (change)="onReportOrgChange()"
                                                >
                                                    <option [ngValue]="''">All Organizations</option>
                                                    @for (org of organizations; track organization_name) {
                                                        <option [ngValue]="org.organization_id">
                                                            {{ org.organization_name }}
                                                        </option>
                                                    }
                                                </select>
                                            </label>
                                        }

                                        @if (
                                            report.isChosen &&
                                            (report.rpt_engine === "JR" || report.report_engine === "JR")
                                        ) {
                                            <s25-ng-report-file-type
                                                [reportId]="report.rpt_id"
                                                [formatType]="report.format || 2"
                                                (modelValueChange)="onReportFormatChange($event)"
                                            >
                                            </s25-ng-report-file-type>
                                        }
                                    </div>
                                }

                                <!-- web service reports -->
                                <div class="report">
                                    <s25-ng-checkbox [(modelValue)]="data.iCalReport" aria-label="icare Report">
                                        iCal File
                                    </s25-ng-checkbox>
                                </div>

                                @if (eventFiles.length > 0) {
                                    <span> {{ eventFiles.length > 1 ? "Event Files:" : "Event File:" }} </span>
                                    @for (file of eventFiles; track "file" + "-" + i; let i = $index) {
                                        <div class="c-margin-left--single">
                                            <s25-ng-checkbox [(modelValue)]="file.isChosen" aria-label="file?.itemName">
                                                {{ file?.itemName }}
                                                @if (file?.cust_atrb_id) {
                                                    <span class="small"> (custom attribute file)</span>
                                                }
                                            </s25-ng-checkbox>
                                        </div>
                                    }
                                }

                                <!-- uploaded files -->
                                <s25-ng-file-upload [showFiles]="true" [onAdd]="handleFileUpload" [multiple]="true">
                                </s25-ng-file-upload>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ngWidth100 c-margin-top--half">
                    <label for="emailSubject" class="ngBold">{{ data?.emailLang?.text?.subject }}</label>
                    <input
                        aria-label="email subject"
                        id="emailSubject"
                        type="text"
                        name="subject"
                        style="width:100%;"
                        [(ngModel)]="data.subject"
                        class="c-input"
                    />

                    <s25-ng-checkbox
                        [(modelValue)]="data.includeLink"
                        (modelValueChange)="onLinkChange(data)"
                        aria-label="include Link"
                    >
                        include link to 25Live
                    </s25-ng-checkbox>
                </div>

                <div class="c-margin-top--half">
                    <div>
                        <label class="ngBold">{{ data?.emailLang?.text?.message_body }}</label>
                        <span class="emailTip ngFinePrint" style="margin-left:25px">
                            {{ data?.emailLang?.text?.event_details_instructions }}
                        </span>
                    </div>

                    <s25-ng-rich-text-editor [(modelValue)]="data.bodyMsg" [autoResize]="true">
                    </s25-ng-rich-text-editor>

                    <s25-ng-checkbox
                        [(modelValue)]="data.isIncludeDetails"
                        (modelValueChange)="onLinkChange(data)"
                        aria-label="isInclude Details"
                    >
                        Include event details in body of message
                    </s25-ng-checkbox>
                </div>

                <div class="scenarioRow">
                    <s25-ng-checkbox [(modelValue)]="isScheduled" aria-label="isScheduled">
                        Scheduled Email
                    </s25-ng-checkbox>
                </div>

                @if (isScheduled) {
                    <div class="scenarioRow">
                        <label>
                            Schedule Type:
                            <select [(ngModel)]="scheduleType" class="cn-form__control">
                                <option value="daysFromEventStart">Days from Event Start</option>
                                <option value="daysFromEventEnd">Days from Event End</option>
                                <option value="daysFromNow">Days from Now</option>
                            </select>
                        </label>

                        <label>
                            Schedule Offset Days:
                            <input type="number" class="c-input" [(ngModel)]="scheduleDays" />
                        </label>
                    </div>
                }
            }

            <div class="aw-button-group">
                <button class="aw-button aw-button--outline" (click)="cancel()">Cancel</button>
                <button class="aw-button aw-button--primary" (click)="getReportRunItemID()" [disabled]="disabled">
                    {{ data?.emailLang?.text?.send_button }}
                </button>
            </div>
        </div>
    `,
    styles: `
        .input-spacer {
            margin-left: 8px;
        }

        .c-emailOnly-editableRecipients {
            border-bottom: 1px dotted currentColor;
            color: #2573a7;
            color: var(--color-primary);
            line-height: 1;
            outline-offset: 2px;
            font-weight: 400;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25EmailEventComponent implements OnInit {
    @Input() itemId: number;
    @Input() apiBean?: apiBean;

    init: boolean = false;

    data: Partial<EventEmailDataI> = {};
    isScheduled: 0 | 1;
    scheduleType: "daysFromEventStart" | "daysFromEventEnd" | "daysFromNow" = undefined;
    scheduleDays: number = undefined;
    reportsEventContractIsChosen: EmailReportSimpleObject[];
    disabled = false;
    hasGlobalFrom: boolean;
    eventFiles: S25File[] = [];
    emailFields: EmailField[];

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        this.elementRef.nativeElement.angBridge = this;
    }

    async ngOnInit() {
        try {
            this.setLoading(true);

            const lang = await LangService.getLang();
            this.data.lang = lang || undefined;
            this.data.files = [];
            this.data.eventLinkFormat = "pro";
            this.data.includeLink = true;
            this.data.emailLang = lang.div.controls["s25-evdetails_email"];
            this.data.ToEmails = { title: this.data?.emailLang?.text?.to };
            this.data.CCEmails = { title: this.data?.emailLang?.text?.cc };
            this.data.BCCEmails = { title: this.data?.emailLang?.text?.bcc };
            this.data.rteId = "messageBodyId-" + Date.now();

            const [
                eventData,
                reportsData,
                dateFormat,
                timeFormat,
                loginData,
                currentEmail,
                sessionId,
                templates,
                fls,
                contracts,
                prefs,
                orgContracts,
                eventTypeReports,
                eventFiles,
            ] = await Promise.all([
                EventService.getEventInclude(this.itemId as number, [
                    "customers",
                    "workflow",
                    "reservations",
                    "organizations",
                ]),
                EventService.getEventReports(this.itemId as number),
                UserprefService.getS25Dateformat(),
                UserprefService.getS25Timeformat(),
                LoginService.getLoginCached(),
                ContactService.getCurrentEmail(),
                UserprefService.getSessionId(),
                BpeService.getManualTemplates(),
                FlsService.getFls(),
                DocumentService.getDocumentList("event"),
                PreferenceService.getPreferences(["EmailFromAddress"], "S"),
                DocumentService.getDocumentList("organization"),
                EventService.getEventTypeReports(),
                AttachmentService.getFileList(1, this.itemId),
                this.data.ToEmails.dataPromise,
                this.data.CCEmails.dataPromise,
                this.data.BCCEmails.dataPromise,
            ]);

            this.hasGlobalFrom = !!prefs?.["EmailFromAddress"]?.value;
            Object.assign(this.data as EventEmailDataI, {
                eventData,
                reportsData,
                dateFormat,
                timeFormat,
                loginData,
                currentEmail,
                sessionId,
                templates,
                fls,
                contracts,
                prefs,
                orgContracts,
                eventTypeReports,
            });

            const contactId = loginData.userId;
            this.data.profiles = S25Util.array.forceArray(eventData.profile);
            this.data.organizations = S25Util.array.forceArray(eventData.organization);

            // Profile selection
            if (this.data && this.data?.profiles?.length > 1) {
                const allProfile = { profile_name: "ALL", profile_id: -999 };
                this.data.chosenProfile = allProfile;
                this.data?.profiles.unshift(allProfile);
            } else {
                this.data.chosenProfile = this.data?.profiles[0];
            }

            this.data.canFrom = fls.EMAIL_OPTIONS === "F";
            this.data.templates = ["R", "C", "F"].includes(fls.SYS_TEMPLATE) ? templates : [];
            this.data.sessionId = sessionId;
            this.data.sender = loginData.contactName;
            this.data.subject = `${eventData.event_name} (${eventData.event_locator})`;
            this.data.subjectClean = this.data?.subject;

            this.data.roles = [];
            if (currentEmail) {
                this.data?.roles.push({
                    roleName: "Self",
                    contactName: this.data?.sender,
                    email: currentEmail,
                });
            }

            this.data.reports = [];
            this.data.hasRole = false;
            this.data.isScheduler = false;

            const roles: Partial<EmailRole>[] = S25Util.array.forceArray(eventData.role) || [];

            if (roles.length) {
                const hasRole =
                    S25Util.valueFind(roles, "contact_id", contactId) ||
                    S25Util.valueFind(eventData, "cur_assigned_to_id", contactId) ||
                    S25Util.valueFind(eventData, "cur_assigned_by_id", contactId) ||
                    S25Util.valueFind(eventData, "approval_contact_id", contactId);

                this.data.hasRole = hasRole;

                this.data.isScheduler =
                    hasRole &&
                    roles.some(
                        (role: EmailRole) =>
                            role.role_id === S25Const.schedulerRole.event &&
                            S25Util.valueFind(role, "contact_id", contactId),
                    );

                for (const role of roles) {
                    if (role?.contact) {
                        this.data?.roles.push({
                            roleName: role.role_name,
                            roleId: role.role_id,
                            contactName: role.contact.contact_name,
                            contactId: role.contact.contact_id,
                            email: role.contact.email,
                        });
                    }
                }

                this.data?.roles.push(
                    {
                        text: this.data?.emailLang?.text?.anyone_with_assignments,
                        email: "assigners",
                    },
                    {
                        text: this.data?.emailLang?.text?.task_recipients,
                        email: "service providers",
                    },
                );

                if (this.data?.isScheduler) {
                    this.data?.roles.push({
                        text: this.data?.emailLang?.text?.event_owner,
                        email: "object owner",
                    });
                }
            }

            if (reportsData && this.data) {
                this.data.reports = reportsData;
                const allContracts = [...contracts, ...orgContracts];

                for (let i = this.data.reports.length - 1; i >= 0; i--) {
                    const r = this.data.reports[i];
                    let remove = false;

                    if (r.rpt_engine === "JR") r.format = 2;

                    if (r.rpt_engine === "DM") {
                        const found = allContracts.find((item) => item.itemName.trim() === r.rpt_name?.trim());
                        if (found) {
                            r.documentId = found.itemId;
                            r.optUUID = found.itemId;
                        } else {
                            remove = true;
                        }
                    }

                    if (r.rpt_use === Report.Use.Confirmation) {
                        r.rpt_name = `Default Confirmation: ${r.rpt_name}`;
                    } else if (r.rpt_use === Report.Use.Invoice) {
                        r.rpt_name = `Default Invoice: ${r.rpt_name}`;
                    }

                    const rptId = r.rpt_id;
                    if (
                        rptId === Report.Reports.ReservationShell.id ||
                        rptId === Report.Reports.EventShell.id ||
                        rptId === Report.Reports.OrganizationShell.id ||
                        r.object_type === Report.ObjectType.PaymentDocument
                    ) {
                        remove = true;

                        if (rptId === Report.Reports.EventShell.id) {
                            for (const c of contracts) {
                                this.data.reports.push({
                                    template_id: rptId,
                                    rpt_id: c.reportId || rptId,
                                    rpt_use: r.rpt_use,
                                    rpt_engine: r.rpt_engine,
                                    rpt_name: `Event Document: ${c.itemName}`,
                                    documentId: c.itemId,
                                    optUUID: c.itemId,
                                });
                            }
                        }

                        if (rptId === Report.Reports.OrganizationShell.id) {
                            for (const c of orgContracts) {
                                this.data.reports.push({
                                    template_id: rptId,
                                    rpt_id: c.reportId || rptId,
                                    rpt_use: r.rpt_use,
                                    rpt_engine: r.rpt_engine,
                                    rpt_name: `Organization Document: ${c.itemName}`,
                                    documentId: c.itemId,
                                    optUUID: c.itemId,
                                    object_type: 13,
                                });
                            }
                        }
                    }

                    if (remove) {
                        this.data.reports.splice(i, 1);
                    }
                }
            }

            this.data.init = true;
            this.setLoading(false);
            this.data.ToEmails.action = () => this.appendEmails(this.data.ToEmails);
            this.data.CCEmails.action = () => this.appendEmails(this.data.CCEmails);
            this.data.BCCEmails.action = () => this.appendEmails(this.data.BCCEmails);

            const allEventFiles = eventFiles || [];

            // Split files into normal and custom attribute files
            const [normalFiles, custAttrFiles] = allEventFiles.reduce<[typeof allEventFiles, typeof allEventFiles]>(
                (acc, f) => {
                    const fileWithFlag = { ...f, isChosen: false };
                    if (f.hasOwnProperty("cust_atrb_id")) {
                        acc[1].push(fileWithFlag);
                    } else {
                        acc[0].push(fileWithFlag);
                    }
                    return acc;
                },
                [[], []], // [normalFiles, custAttrFiles]
            );

            // Filter custom attribute files that user has right to view
            const filteredCustAttrFiles = await ObjectDetailsUtil.filterMasterDefinitions(
                "getEventCustomAttributes",
                custAttrFiles,
                "cust_atrb_id",
                [true],
            );
            // Combine both arrays
            this.eventFiles = normalFiles.concat(filteredCustAttrFiles);

            this.emailFields = ["To", "CC", "BCC"].map((label) => {
                const key = label + "Emails";
                return {
                    id: key,
                    label,
                    buttonText: label.toUpperCase(),
                    model: this.data[key as keyof typeof this.data],
                };
            }) as EmailField[];

            this.init = true;
            this.cd.detectChanges();
        } catch (error) {
            console.error("Initialization failed:", error);
            this.setLoading(false);
        }
    }

    appendEmails(target: { addedItems?: S25ItemI[]; emailList?: string }) {
        const selected = target?.addedItems || [];
        const emailList = selected.map((item) => item.itemDesc).join(", ");

        target.emailList = target.emailList ? target.emailList + ", " + emailList : emailList;
    }

    getCleanEmails(emailString: string) {
        return S25Util.array
            .unique(
                emailString
                    .split(/[,\s;]/)
                    .map(S25Util.trim)
                    .filter(S25Util.isTruthy)
                    .filter(S25Util.isValidEmail),
            )
            .join(", ");
    }

    getFinalContactString(currentContactString: string, roleChooseProp: keyof EmailRole): string {
        const current = currentContactString?.trim() || "";

        const rolesString = (this.data.roles || [])
            .filter((role) => !!role[roleChooseProp])
            .map((role) => role.email)
            .filter(Boolean) // removes null/undefined
            .join(", ");

        // Merge both parts into one string
        let finalString = [current, rolesString].filter(Boolean).join(", ");

        if (finalString) {
            const arr = finalString.split(/[,;]/).map(S25Util.trim).filter(S25Util.isTruthy);

            finalString = S25Util.array.unique(arr).join(", ");
        }

        return finalString || "";
    }

    getReportRunItemID() {
        this.reportsEventContractIsChosen = this.data?.reports?.filter((obj: EmailReportObject) => {
            return obj.isChosen && (obj.template_id === -198 || obj.template_id === -217 || obj.rpt_engine === "DM"); // ANG-5852 DM
        }) as EmailReportSimpleObject[];

        let getEventDocumentRunId: EmailReportSimpleObject[] = [];
        if (this.reportsEventContractIsChosen.length > 0) {
            this.reportsEventContractIsChosen.forEach((report: EmailReportSimpleObject) => {
                DocumentService.getEventDocumentRunId(report.documentId as number, this.itemId as number).then(
                    (resp) => {
                        getEventDocumentRunId.push({
                            template_id: report.template_id,
                            rpt_id: report.rpt_id,
                            rpt_use: report.rpt_use,
                            rpt_engine: report.rpt_engine,
                            rpt_name: report.rpt_name,
                            params: report.params,
                            documentId: report.documentId,
                            optUUID: report.optUUID,
                            itemID: resp,
                            isChosen: true,
                        });

                        if (getEventDocumentRunId.length === this.reportsEventContractIsChosen.length) {
                            this.reportsEventContractIsChosen = getEventDocumentRunId;
                            this.send();
                        }
                    },
                );
            });
        } else {
            this.send();
        }
    }

    send() {
        this.disabled = true;
        try {
            setTimeout(() => {
                //ANG-2674: wait timeout to allow model to update in case ngModel update was missed somehow
                let tos, from, ccs, bccs, reports, emailBody;
                let uploadedFiles: { name: string; data: string }[];
                from = this.data?.fromEmail;
                tos = this.getFinalContactString(this.data?.ToEmails?.emailList, "isChosenTo");
                ccs = this.getFinalContactString(this.data?.CCEmails?.emailList, "isChosenCC");
                bccs = this.getFinalContactString(this.data?.BCCEmails?.emailList, "isChosenBCC");
                const reportsIsChosen = this.data?.reports?.filter(
                    (obj: EmailReportObject) =>
                        obj.isChosen && obj.template_id !== -198 && obj.template_id !== -217 && obj.rpt_engine !== "DM",
                );

                reports = reportsIsChosen.concat(this.reportsEventContractIsChosen) as EmailReport[];

                let webServiceFiles = this.data?.iCalReport
                    ? [DataAccess.getUrl(`/event.ics?event_id=${this.itemId}&session_id=${this.data?.sessionId}`)]
                    : [];

                uploadedFiles =
                    this.data?.files
                        ?.filter((obj) => obj.isChosen)
                        .map((obj) => ({
                            name: obj.name,
                            data:
                                typeof obj.data === "string"
                                    ? obj.data
                                    : btoa(String.fromCharCode(...new Uint8Array(obj.data))),
                        })) ?? [];

                let eventFiles: string[] = this.eventFiles.filter((f) => f.isChosen).map((f) => f.itemName);

                //eventFiles payload same as  webservices, so push eventFiles to webServiceFiles
                if (eventFiles.length > 0) webServiceFiles = webServiceFiles.concat(eventFiles);

                emailBody = EventEmailService.formEventEmail(
                    this.data?.bodyMsg ?? "",
                    this.data?.sender ?? "",
                    this.data?.isIncludeDetails ?? false,
                    this.data?.eventData,
                    this.itemId ?? 0,
                    this.data?.dateFormat,
                    this.data?.timeFormat,
                    S25Const.baseUrl,
                    this.data?.emailLang,
                    this.data?.eventLinkFormat,
                    this.data?.chosenTemplate?.itemId,
                );

                if (this.isScheduled) {
                    TelemetryService.sendWithSub("EventDetails", "Email", "Schedule");
                }

                let emailPromise = EmailService.sendEmail(
                    this.data?.subject ?? "",
                    emailBody,
                    tos,
                    from,
                    ccs,
                    bccs,
                    reports,
                    webServiceFiles,
                    uploadedFiles,
                    this.itemId,
                    1,
                    this.data?.chosenTemplate?.itemId || 0,
                    {
                        itemId: 0,
                        isScheduled: this.isScheduled,
                        scheduleType: this.scheduleType,
                        scheduleDays: this.scheduleDays,
                    },
                    S25Util.generateQuickGUID(),
                )
                    .then((resp) => {
                        if (resp && resp.error) {
                            NotificationService.post("Email(s) failed: " + resp.error);
                            this.disabled = false;
                        } else {
                            NotificationService.post("Email(s) have been successfully sent");
                            this.cancel();
                        }
                    })
                    .catch((resp) => {
                        NotificationService.post("Email(s) failed: " + S25Util.errorText(resp, "Uncaught Error"));
                        this.disabled = false;
                    });
                NotificationService.post("Email(s) are sending...", emailPromise);
            }, 250);
        } catch (e) {
            NotificationService.post("Email(s) failed: " + (e.message || "Uncaught Error"));
        }
    }

    cancel() {
        this.apiBean?.closeActionsBody?.();
        this.data.chosenTemplate = undefined;
        this.data.subject = this.data?.subjectClean || "";
        this.data.bodyMsg = "";

        this.disabled = false;
        this.data.fromEmail = "";
        this.data.ToEmails.emailList = this.getCleanEmails("");
        this.data.CCEmails.emailList = this.getCleanEmails("");
        this.data.BCCEmails.emailList = this.getCleanEmails("");

        this.data.eventLinkFormat = "pro";
        this.data.includeLink = true;
        this.data.isIncludeDetails = false;
        this.data.iCalReport = false;

        this.data?.roles?.forEach((role) => {
            role.isChosenTo = false;
            role.isChosenCC = false;
            role.isChosenBCC = false;
        });

        this.data?.reports?.forEach((report) => {
            report.isChosen = false;
        });

        this.data.files = [];
    }

    async chooseTemplate(): Promise<void> {
        try {
            this.setLoading(true);

            const eventData = await BpeService.getEventData(this.itemId as number, true, true);
            await BpeService.getAdditionalEventData({ postEventDataPromise: Promise.resolve(eventData) });

            let profileId = this.data?.chosenProfile?.profile_id as number | null;
            profileId = profileId === -999 ? null : profileId;

            const email = await BpeService.getEmailObjectFromTemplate(
                eventData,
                profileId ?? null,
                this.data?.chosenTemplate,
            );

            // Add "object owner" role if referenced in email and user is not scheduler
            if (
                !this.data?.isScheduler &&
                ["to", "cc", "bcc"].some((field) => (email[field] || "").includes("object owner"))
            ) {
                S25Util.array.inplacePushByProp(this.data?.roles, "email", "objectOwner", {
                    text: this.data?.emailLang?.text?.event_owner,
                    email: "object owner",
                });
            }

            // Reset all roles and assign based on email
            this.data?.roles?.forEach((r) => {
                r.isChosenTo = false;
                r.isChosenCC = false;
                r.isChosenBCC = false;

                const role = r.text ? r.email : r.roleName;
                const regex = new RegExp(`${role}($|[,;'"\s])`, "i");

                r.isChosenTo = regex.test(email.to || "");
                r.isChosenCC = regex.test(email.cc || "");
                r.isChosenBCC = regex.test(email.bcc || "");
            });

            // Populate email fields
            this.data.fromEmail = email.from;
            this.data.showFrom = !!(this.data?.fromEmail && this.data?.canFrom);
            this.data.ToEmails.emailList = this.getCleanEmails(email.to || "");
            this.data.CCEmails.emailList = this.getCleanEmails(email.cc || "");
            this.data.BCCEmails.emailList = this.getCleanEmails(email.bcc || "");
            this.data.subject = S25Util.unescapeXml(email.subject || "");
            this.data.bodyMsg = email.body || "";
            this.data.isIncludeDetails = false;
            this.data.iCalReport = this.data?.chosenTemplate?.iCalFile === 1;

            // Handle reports
            const reportTokens: string[] = email.reports?.split(",").map((s: string) => s.trim()) || [];
            const reportsHash: Record<string, boolean> = {};
            const eventTypeReports = this.data?.eventTypeReports ?? [];

            const sortedReports = [...(this.data?.reports ?? [])].sort(S25Util.shallowSort("rpt_use", true, true));

            sortedReports.forEach((r) => {
                r.isChosen = false;

                for (const token of reportTokens) {
                    if (reportsHash[token]) continue;

                    const tokenId = parseInt(token);
                    const isConfirmation = token === "confirmation" && parseInt(r.rpt_use) === 1;
                    const isInvoice = token === "invoice" && parseInt(r.rpt_use) === 2;
                    const idMatch = !isNaN(tokenId) && tokenId === parseInt(r.rpt_id);
                    const eventMatch = eventTypeReports.some(
                        (et: EmailReportObject) => tokenId === et.report_id && parseInt(r.rpt_id) === et.report_id,
                    );

                    if (isConfirmation || isInvoice || idMatch || eventMatch) {
                        r.isChosen = true;
                        reportsHash[token] = true;
                    }
                }
            });
        } catch (error) {
            console.error("Failed to choose template:", error);
            NotificationService.post("Failed to load email template: " + (error.message || "Unknown error"));
        } finally {
            this.setLoading(false);
        }
    }

    addFrom() {
        this.data.showFrom = true;
    }

    chooseProfile() {
        if (this.data?.chosenProfile && this.data?.chosenTemplate) {
            return this.chooseTemplate();
        }
    }

    onLinkChange(data: string) {
        if (!data) {
            this.data.eventLinkFormat = "noLink";
        } else {
            this.data.eventLinkFormat = "pro";
        }
    }

    onReportFormatChange(data: EmailReportObject): void {
        if (!this.data?.reports) return;

        const reports = [...this.data.reports];

        for (let i = 0; i < reports.length; i++) {
            if (reports[i].rpt_id === data.reportId) {
                reports[i].format = data.formatType;
                break;
            }
        }

        this.data.reports = reports as EmailReportObject[];
    }

    onReportOrgChange(report: Report.Object) {
        let reports = this.data?.reports || [];
        for (let i = 0; i < reports?.length; i++) {
            if (reports[i].rpt_id === report.rpt_id) {
                //Once we send an org_id parameter we need to also include the eventId as a parameter for emails
                if (report.orgId) {
                    reports[i].params = reports[i].params || {};
                    Object.assign((reports[i].params ??= {}), {
                        num_parm4: report.orgId,
                        num_parm1: this.itemId,
                    });
                } else if (reports[i]?.params) {
                    //fall back to no special report parameters
                    delete reports[i].params;
                }
                break;
            }
        }
    }

    handleFileUpload = async (file: S25File): Promise<void> => {
        this.data.files.push(file);
    };

    setLoading(yes: boolean) {
        if (yes) {
            S25LoadingApi.init(this.elementRef.nativeElement);
        } else {
            S25LoadingApi.destroy(this.elementRef.nativeElement);
        }
        this.cd.detectChanges();
    }
}
